import { StatusIcon } from './StatusIcon'
import { getStatusColor } from './StatusColor'
import type { MonthPlanFact } from '@/features/history/types'

interface CompletionBadgeProps {
  metric: MonthPlanFact
}

export function CompletionBadge({ metric }: CompletionBadgeProps) {
  if (metric.plan === 0) {
    return <span className="text-muted-foreground">-</span>
  }
  return (
    <div className={`flex items-center justify-center gap-1 ${getStatusColor(metric.completion)}`}>
      <StatusIcon completion={metric.completion} />
      <span className="font-bold text-sm">{Math.round(metric.completion)}%</span>
    </div>
  )
}
